define(function (require) {
    require("@modules/tools/ko.bootstrapSelect");
    require("@modules/tools/ko.bootstrap-select");
    require("@modules/tools/ko.bootstrapSelect.typeahead");

    require("@modules/tools/ko.scrollTo");
    require("@modules/tools/ko.dpOpenClose");
    require("@plugins/knockout-multi-select/main");

    var ko = require("knockout");
    var $ = require("jquery");
    var FormularySearchViewModel = require("@modules/tools/formulary-search/formularySearchViewModel");

    var gtmDataLayerPush = function (parameters, defaultParameters) {
        var dataLayer = window.dataLayer || [];

        var url = window.location.href.replace(/^.*\/\/[^\/]+/, "").split("?")[0];
        var jsonObject = {
            event: "gaPageview",
            eventCategory: "Pageview",
            eventAction: url,
            eventLabel: "Formulary Search"
        };

        if (parameters.year && parameters.year !== defaultParameters["year"]) {
            dataLayer.push({
                event: "gaEvent",
                eventCategory: "Lookup-formulary",
                eventAction: "Year",
                eventLabel: parameters.year
            });
        }
        if (parameters.category && parameters.category !== defaultParameters["category"]) {
            dataLayer.push({
                event: "gaEvent",
                eventCategory: "Lookup-formulary",
                eventAction: "DrugTherapeuticTypeID",
                eventLabel: parameters.category
            });

            jsonObject.formularyCategory = parameters.category;
        }
        if (parameters.drugName && parameters.drugName !== defaultParameters["drugName"]) {
            dataLayer.push({
                event: "gaEvent",
                eventCategory: "Lookup-formulary",
                eventAction: "DrugName",
                eventLabel: parameters.drugName
            });

            jsonObject.formularyName = parameters.drugName;
        }
        if (parameters.browseLetter && parameters.browseLetter !== defaultParameters["browseLetter"]) {
            dataLayer.push({
                event: "gaEvent",
                eventCategory: "Lookup-formulary",
                eventAction: "BrowseLetter",
                eventLabel: parameters.browseLetter
            });

            jsonObject.formularyBrowseLetter = parameters.browseLetter;
        }
        /*
        {
            "year": 2018,
            "category": ["Analgesics"],
            "coverageLimits": ["HasStepTherapy", "HasQuantityLimit", "HasPA"],
            "tierNumber": ["1"],
            "pageNumber": 1,
            "pageSize": 4
        }
         */

        dataLayer.push(jsonObject);
    };

    if ($("#formulary-search").length > 0) {
        ko.applyBindings(new FormularySearchViewModel(gtmDataLayerPush));
        $(".hide-load").removeClass("hide-load");
        $(".tool-load").removeClass("tool-load");
    }
});
